import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Store from "./context/Store";

// --- Suppress ResizeObserver warnings globally (harmless) ---
const resizeObserverErr =
  /ResizeObserver loop completed with undelivered notifications./;
const resizeObserverErrLimit = /ResizeObserver loop limit exceeded/;

window.addEventListener("error", (event) => {
  if (
    resizeObserverErr.test(event.message) ||
    resizeObserverErrLimit.test(event.message)
  ) {
    event.stopImmediatePropagation();
  }
});

window.addEventListener("unhandledrejection", (event) => {
  if (resizeObserverErr.test(event.reason?.message)) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Store>
    <App />
  </Store>,

  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
